
export const rectanguloByLayerName = {
  'KAIROS:EU_025_live_demo': [[73, -27], [33, 45]],
  'KAIROS:EU_0125_live_demo': [[60, -10], [36, 25]],
  'CNN:EU_025_live_demo': [[73, -27], [33, 45]],
  'CNN:EU_01_live_demo': [[64, -16], [33, 45]],
  'CNN:euro_1k_00625_15m': [[33, -10.0625], [56.4375, 21.6875]],
  'VISIBILITY:visibility_live_demo': [[73, -27], [27, 45]],
  'NOWCASTING:nowcastnet_live_demo': [[63.4, -11.6], [42.69, 15.85]],
  'ICE:ICE_025_live_demo': [[73, -27], [33, 45]],
  'TURBULENCE:TURBULENCE_0125_live_demo': [[70, -10], [35, 30]],
  'DUST:DUST_025_live_demo': [[63.25, -12.5], [-0.5, 51.25]]
};

export const buttonLabels = {
  'KAIROS:EU_025_live_demo': 'Convection (~28km)',
  'KAIROS:EU_0125_live_demo': 'Convection (~14km)',
  'CNN:EU_025_live_demo': 'Convection (~28km)',
  'CNN:EU_01_live_demo': 'Convection (~9km)',
  'CNN:euro_1k_00625_15m': 'Convection (~6km)',
  'VISIBILITY:visibility_live_demo': 'Visibility Europe',
  'NOWCASTING:nowcastnet_live_demo': 'Precipitation',
  'ICE:ICE_025_live_demo': 'HAIC',
  'TURBULENCE:TURBULENCE_0125_live_demo': 'Turbulence (~14km)',
  'DUST:DUST_025_live_demo': 'Dust (~28km)'
};

export const shortLabels = {
  'KAIROS:EU_025_live_demo': '025',
  'KAIROS:EU_0125_live_demo': '0125',
  'CNN:EU_025_live_demo': '025',
  'CNN:EU_01_live_demo': '01',
  'CNN:euro_1k_00625_15m': '00625',
  'VISIBILITY:visibility_live_demo': 'vsb',
  'NOWCASTING:nowcastnet_live_demo': 'rain',
  'ICE:ICE_025_live_demo': 'HAIC',
  'TURBULENCE:TURBULENCE_0125_live_demo': 'tbl',
  'DUST:DUST_025_live_demo': 'dust'
};

export const layerIcons = {
  'KAIROS:EU_025_live_demo': 'Thunderstorm',
  'KAIROS:EU_0125_live_demo': 'Thunderstorm',
  'CNN:EU_025_live_demo': 'Thunderstorm',
  'CNN:EU_01_live_demo': 'Thunderstorm',
  'CNN:euro_1k_00625_15m': 'Thunderstorm',
  'VISIBILITY:visibility_live_demo': 'Visibility',
  'NOWCASTING:nowcastnet_live_demo': 'WaterDrop',
  'ICE:ICE_025_live_demo': 'AcUnit',
  'TURBULENCE:TURBULENCE_0125_live_demo': 'Air',
  'DUST:DUST_025_live_demo': 'LensBlur'
};

export const iconComponents = {
  Thunderstorm: 'ThunderstormIcon',
  Visibility: 'VisibilityIcon',
  WaterDrop: 'WaterDropIcon',
  AcUnit: 'AcUnitIcon',
  Air: 'AirIcon',
  LensBlur: 'LensBlurIcon'
};

export const layerCategories = {
  convection: [
    'KAIROS:EU_025_live_demo',
    'KAIROS:EU_0125_live_demo',
    'CNN:EU_025_live_demo',
    'CNN:EU_01_live_demo'
  ],
  weather: [
    'VISIBILITY:visibility_live_demo',
    'NOWCASTING:nowcastnet_live_demo',
    'ICE:ICE_025_live_demo',
    'TURBULENCE:TURBULENCE_0125_live_demo',
    'DUST:DUST_025_live_demo'
  ]
};
